import { LeadAPIRequest } from "src/ssc-api/leadAPIClient";
import { LeadFormData } from "./types";
import { toUTCDate } from "../../utils/date";
import { isPresent } from "src/utils/checks";
import { buildGetRequest, useFetchApi } from "src/ssc-api/useFetchApi";
import { stringPresent } from "src/utils/strings";
import { StateFromCountryApiRequest } from "@silversea-ssc/dotcom-api-types/StatesFromCountry";
import { CruiseSuiteFormProps } from "./useLeadForm";

export interface Country {
  name: string;
  code: string;
  iso3Code: string;
}

function booleanToInt(value: boolean | 1 | 0 | undefined): 1 | 0 | undefined {
  if (!isPresent(value)) return undefined;
  return value ? 1 : 0;
}

export function formDataToLeadAPIRequest(
  formData: LeadFormData
): LeadAPIRequest {
  const {
    IsNotAgent,
    WorkingWithAgent,
    SailDate,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    RequestType,
    Price,
    ...otherFormData
  } = formData;

  const parsedPrice = parsePrice(Price);

  const request: LeadAPIRequest = {
    ...otherFormData,
    Country: formData.Country || formData.SiteCountry, //all leads should have a country even for digital stuff
    ...(isPresent(SailDate) && { SailDate: toUTCDate(SailDate) }),
    ...(isPresent(IsNotAgent) && { IsAgent: booleanToInt(!IsNotAgent) }),
    ...(isPresent(WorkingWithAgent) && {
      WorkingWithAgent: booleanToInt(WorkingWithAgent)
    }),
    ...(isPresent(parsedPrice) && { Price: parsedPrice }),
    RequestType: RequestType,
    RequestDate: new Date()
  };

  return request;
}

export function cruiseSuiteInfoToLeadFormData(
  cruiseSuiteInfo: CruiseSuiteFormProps | undefined
): Partial<LeadFormData> {
  if (!cruiseSuiteInfo) return {};
  return {
    VoyageCod: cruiseSuiteInfo.voyageCode,
    Voyage: cruiseSuiteInfo.voyageName,
    Ship: cruiseSuiteInfo.shipName,
    SailDate: cruiseSuiteInfo.departureDate,
    Price: parsePrice(cruiseSuiteInfo.price),
    SuiteVariation: cruiseSuiteInfo.suiteVariation
    //SuiteCategory: ""
    //ArrivalPort: "",
    //DeparturePort:
  };
}

function parsePrice(price: number | string | undefined): number | undefined {
  if (typeof price === "string") {
    if (price == "") return undefined;
    return Number(price);
  }

  return price;
}

export const useGetStatesForCountry = (
  country: string | undefined
): string[] => {
  const url = stringPresent(country)
    ? buildGetRequest<StateFromCountryApiRequest>("statesFromCountry", {
        country: country
      })
    : undefined;

  const { data } = useFetchApi<string[]>(url, ["states", country || "none"]);
  return data || [];
};

export const useGetCountries = (enable: boolean): Country[] => {
  const url = enable ? buildGetRequest("countries") : undefined;
  const { data } = useFetchApi<Country[]>(url, ["countries"]);
  return data || [];
};
